import { createFileRoute } from '@tanstack/react-router';
import { PlansPage } from '../../features/billing';

const FEATURE_RE = /^[a-z][a-z0-9_]*(\.[a-z][a-z0-9_]*)+$/;

export const Route = createFileRoute('/portal/billing/plans')({
  // `?feature=` comes from the 402 upsell's upgrade_url: that feature is highlighted.
  validateSearch: (s: Record<string, unknown>): { feature?: string } =>
    typeof s.feature === 'string' && FEATURE_RE.test(s.feature) ? { feature: s.feature } : {},
  component: function PlansRoute() {
    const { feature } = Route.useSearch();
    return <PlansPage feature={feature} />;
  },
});
